const configSystemInitialState = {
    errorConfigSystem: true,
    config: {
        website_company: '',
        website_title: '',
        website_name: '',
        website_email: '',
        website_address: '',
        website_domain: '',
        website_phone: '',
        website_facebook_url: '',
        website_logo: '',
        website_logo_w: '',
        website_favicon: '',
    },
    autoBanking: false,
    template: false,
    live_chat: false,
    telegram: false,
    mail_marketing: false,
    configLiveChat: '',
}

const configSystem = (state = configSystemInitialState, action) => {
    switch (action.type) {
        case 'updateSystem':
            return { ...state, errorConfigSystem: false, config: action.item }
        case 'updateLicense':
            return {
                ...state, autoBanking: action.item.autoBanking,
                template: action.item.template, live_chat: action.item.live_chat,
                telegram: action.item.telegram, mail_marketing: action.item.mail_marketing,
            }
        case 'updateTextLiveChat':
            return { ...state, configLiveChat: action.item.configLiveChat }
        default:
            return state
    }
}

export default configSystem;